import {
  DEFAULT_SCRAPE_COUNTRY_CODE,
  SCRAPE_COUNTRY_CODES,
  type ScrapeCountryCode,
} from "contracts/enums/scrape-country";

// One wording for the setting wherever it is edited (creation and settings).
export const COUNTRY_FIELD_LABEL =
  "Analyse from (pages are loaded from this country)";

// Display names come from the platform's region table rather than a checked-in
// label map, so the code list stays the only thing tracking ScrapingBee.
const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

function label(code: string): string {
  return regionNames.of(code.toUpperCase()) ?? code.toUpperCase();
}

// Default first, then alphabetical: the common choice is one click away and the
// rest are scannable.
export const COUNTRY_OPTIONS: readonly {
  value: ScrapeCountryCode;
  label: string;
}[] = [
  {
    value: DEFAULT_SCRAPE_COUNTRY_CODE,
    label: label(DEFAULT_SCRAPE_COUNTRY_CODE),
  },
  ...SCRAPE_COUNTRY_CODES.filter((code) => code !== DEFAULT_SCRAPE_COUNTRY_CODE)
    .map((code) => ({ value: code, label: label(code) }))
    .sort((a, b) => a.label.localeCompare(b.label)),
];
